<template>
  <div class="app-radio">
    <input
      type="radio"
      :name="name"
      :value="value"
      :id="id"
      class="app-radio__input"
      :checked="checked"
      :disabled="disabled"
      @change="onChange"
    />
    <label
      :for="id"
      class="app-radio__label"
      :class="[
        { disabled: disabled, border: hasBorder },
        `app-radio__label--${size}`
      ]"
      >{{ text }}</label
    >
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
type ButtonSize = "normal" | "small";

@Component
export default class AppRadio extends Vue {
  @Prop({
    type: [String, Number],
    required: true,
    default: ""
  })
  value!: string | number;

  @Prop({
    type: String,
    required: true,
    default: ""
  })
  name!: string;

  @Prop({
    type: String,
    required: true,
    default: ""
  })
  id!: string;

  @Prop({
    type: String,
    required: true,
    default: ""
  })
  text!: string;

  @Prop({
    type: Boolean,
    default: false
  })
  disabled!: boolean;

  @Prop({
    type: Boolean,
    required: true,
    default: false
  })
  checked!: boolean;

  @Prop({
    type: String,
    default: "normal"
  })
  size!: ButtonSize;

  @Prop({
    type: Boolean,
    default: true
  })
  hasBorder!: boolean;

  onChange(v: Event) {
    if (!(v.target instanceof HTMLInputElement)) {
      return;
    }
    this.$emit("change", v.target.value);
  }
}
</script>

<style lang="scss" scoped>
.app-radio {
  &__input {
    display: none;
  }

  &__label {
    position: relative;
    display: flex;
    align-items: center;
    margin-bottom: 0;
    color: $primary-dark;
    background-color: $white;

    .border {
      content: "";
      border: 1px solid $gray-04;
      border-radius: 4px;
    }

    .app-radio__input:checked + & {
      border-color: $blue;
    }

    &::before {
      display: block;
      margin-right: 8px;
      content: "";
      background-color: $gray-03;
      border-radius: 50%;

      .app-radio__input:checked + & {
        background-color: $blue;
        border: 4px solid $light-blue;
      }
    }

    &--normal {
      padding: 6px 8px;
    }

    &--normal::before {
      width: 20px;
      min-width: 20px;
      height: 20px;
      min-height: 20px;
    }

    &--small {
      padding: 0;
      font-size: 12px;
    }

    &--small::before {
      width: 15px;
      min-width: 15px;
      height: 15px;
      min-height: 15px;
    }
  }
}

.disabled {
  background-color: #e5e5e5;
}
</style>
